import { createContext, useCallback, useContext, useRef, useState } from "react";

const Ctx = createContext(() => { });
export const useToast = () => useContext(Ctx);

export function ToastProvider({ children }) {
  const [t, setT] = useState(null);
  const h = useRef(null);
  const show = useCallback(msg => {
    setT({ msg, on: true });
    clearTimeout(h.current);
    h.current = setTimeout(() => setT(x => ({ ...x, on: false })), 3200);
  }, []);
  return (
    <Ctx.Provider value={show}>
      {children}
      {t ? <div id="toast" className={"toast" + (t.on ? " on" : "")} role="status" data-testid="toast">{t.msg}</div> : null}
    </Ctx.Provider>
  );
}
